import { Injectable } from "@angular/core";

import * as L from 'leaflet';
import 'leaflet-easybutton';
import {Google} from "../utils/google";
import { LeafletLocation } from "@mocca-technologies/model";
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { SearchResult } from 'leaflet-geosearch/dist/providers/provider';

@Injectable({
  providedIn: 'root'
})
export class LeafletService {
    map!: L.Map;

    baseLayers = {
        'Google Satellite': new Google('SATELLITE', { id: 'base' }),
        'Open Street Map': new L.TileLayer(
            "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            id: 'base',
            maxNativeZoom: 18,
            maxZoom: 21
        }),
        'Arc GIS': new L.TileLayer(
            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png", {
            id: 'base',
            maxNativeZoom: 18,
            maxZoom: 21
        })
    };

    options = {
        attributionControl: false,
        zoomControl: false,
        layers: [this.baseLayers['Google Satellite']],
        center: new L.LatLng(41.4, 2.1),
        zoom: 12
    };

    controlOptions = { collapsed: false };

    setupMap(map: L.Map): void {
        map.invalidateSize();
        this.map = map;
    }

    private addButton(callback: () => void): void {
        L.easyButton('test button', callback).addTo(this.map);
    }

    /**
   * This service is used to geocode a location using the OpenStreetMap Nominatim API.
   * @param location
   * @returns
   */
  async searchLocation(location: string): Promise<LeafletLocation[]> {

    const locationProvider = new OpenStreetMapProvider();

    const results = await locationProvider.search({ query: location });

    return results.map((result: SearchResult) => ({
      lat: result.y,
      lon: result.x,
      label: result.label,
      bounds: result.bounds ? [
        result.bounds[0][0],
        result.bounds[0][1],
        result.bounds[1][0],
        result.bounds[1][1]
      ] : [] }));
  }
}
